import {
  Tooltip,
  Typography,
  IconButton,
  Divider,
  CardActions,
  Button,
  Chip,
  Paper,
  Popper,
  MenuList,
  MenuItem,
  ClickAwayListener,
} from '@material-ui/core';
import SpellcheckIcon from '@material-ui/icons/Spellcheck';
import CheckIcon from '@material-ui/icons/Check';
import EditIcon from '@material-ui/icons/Edit';
import DoneAllIcon from '@material-ui/icons/DoneAll';

export const reviewerName = (currentName) => {
  if (currentName === 'bbox') return 'b-box plus';
  else return currentName;
};

export const getCurrentModuleStatus = (
  appliedResult,
  shownResult,
  isConfirmed,
  isRelabeled,
  moduleToConfirm,
  theme,
  t,
) => {
  const icon_button = {
    height: '16px',
    width: '16px',
    minHeight: '16px',
    minWidth: '16px',
    '&:hover': {
      background: `${theme.palette.accents.main} !important`,
      boxShadow: '0px 0px 5px 0px #d7c2c2',
    },
  };

  if (isRelabeled) {
    return {
      buttonText: t('ResultView.reannotated'),
      currentApplied: `${t('ResultView.appliedRevision')}: ${reviewerName(appliedResult)}`,
      tooltipAction:
        appliedResult === shownResult ? t('ResultView.label_discard_icon') : t('ResultView.confirm_current'),
      fabIcon:
        appliedResult === shownResult ? (
          <SpellcheckIcon fontSize='medium' style={{ width: '14px', height: '14px', marginRight: '2px' }} />
        ) : null,
      color: appliedResult === shownResult ? '#246767' : '#6d6d6d',
    };
  } else if (isConfirmed)
    return {
      buttonText: t('ResultView.label_confirmed'),
      currentApplied: `${t('ResultView.label_confirmed')}: ${reviewerName(appliedResult)}`,
      tooltipAction:
        appliedResult === shownResult ? t('ResultView.label_discard_icon') : t('ResultView.confirm_current'),
      fabIcon:
        appliedResult === shownResult ? (
          <DoneAllIcon fontSize='medium' style={{ width: '14px', height: '14px', marginRight: '2px' }} />
        ) : null,
      color: appliedResult === shownResult ? '#246767' : '#6d6d6d',
    };
  else
    return {
      buttonText: t('ResultView.confirm'),
      currentApplied:
        shownResult === 'bbox'
          ? t('ResultView.org_pred')
          : `${t('ResultView.relabeled')}: ${reviewerName(shownResult)}`,
      tooltipAction: t('ResultView.btn_confirm', { module: moduleToConfirm }),
      fabIcon: <CheckIcon fontSize='small' style={icon_button} />,
      color: '#515151',
    };
};

export const TooltipBadgeFab = ({
  content,
  open,
  badgeContent,
  onClick,
  onMouseEnter,
  onMouseLeave,
  popperContent,
  anchorRef,
  popperOpen,
  classes,
  theme,
  t,
  style,
}) => {
  return (
    <Tooltip placement='right-end' arrow title={content} open={open}>
      <span>
        <Chip
          label={badgeContent}
          variant='outlined'
          onClick={onClick}
          size='small'
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          ref={anchorRef}
          style={{
            ...style,
            height: '20px',
            minHeight: '20px',
            fontSize: theme.fonts.responsiveMedium,
            minWidth: '70px',
            border: `1px solid ${theme.palette.accents.main}`,
            color: theme.palette.accents.main,
          }}
        />

        <Popper
          open={popperOpen}
          anchorEl={anchorRef.current}
          placement='bottom-start'
          disablePortal={false}
          keepMounted={false}
          modifiers={{
            flip: {
              enabled: true,
            },
            preventOverflow: {
              enabled: true,
              boundariesElement: 'scrollParent',
            },
          }}>
          <Paper className={classes.popperPaper}>{popperContent}</Paper>
        </Popper>
      </span>
    </Tooltip>
  );
};
